import React, { useState, useEffect, useContext } from "react";
import { Button, Col, Row, Table } from "reactstrap";
import { numberToText } from "../../../Utils/otherFunctions";
import SignTable from "./TableSign";
import SignForm from "./ModalYangMenyerahkan";
import RoleContext from "../../../Context/RoleContext";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const DetailTandaTerima = ({ data, toggle }) => {
  const tandaTerimaAPI = useTandaTerima();
  const { checkPermission } = useContext(RoleContext);
  // const axiosInstance = useAxios();
  const [penerimaList, setPenerimaList] = useState([]);
  const [pemberiTugasList, setPemberiTugasList] = useState([]);
  const [yangMenyerahkanList, setYangMenyerahkanList] = useState([]);

  useEffect(() => {
    if (data?.id_tanda_terima) {
      refreshPenerima();
      refreshPemberiTugas();
      refreshYangMenyerahkan();
    }
  }, [data?.id_tanda_terima]);

  const refreshPenerima = () => {
    tandaTerimaAPI.getPenerima(data.id_tanda_terima).then((res) => {
      setPenerimaList(res.data);
    });
  };

  const refreshPemberiTugas = () => {
    tandaTerimaAPI.getPemberiTugas(data.id_tanda_terima).then((res) => {
      setPemberiTugasList(res.data);
    });
  };

  const refreshYangMenyerahkan = () => {
    tandaTerimaAPI.getYangMenyerahkan(data.id_tanda_terima).then((res) => {
      setYangMenyerahkanList(res.data);
    });
  };

  const cetakTandaTerima = (id) => {
    tandaTerimaAPI.getTandaTerimaCetak(id, toggle);
  };

  const numbering = (list) => {
    const listCleaned = list.split("\n");
    return (
      <ol>
        <Col>
          {listCleaned.map((penerima, index) => (
            <Row key={index}>
              <li>{penerima}</li>
            </Row>
          ))}
        </Col>
      </ol>
    );
  };

  return (
    <div className="d-flex flex-column">
      <Table>
        <tbody>
          <tr>
            <th style={{ borderBottom: "1px solid black" }} scope="row">
              Dari
            </th>
            <td style={{ borderBottom: "1px solid black" }}>{data.dari}</td>
          </tr>
          {data.unit_kerja && (
            <tr>
              <th style={{ borderBottom: "1px solid black" }} scope="row">
                Divisi
              </th>
              <td style={{ borderBottom: "1px solid black" }}>
                {data.unit_kerja_nama}
              </td>
            </tr>
          )}
          {data.nomor_surat && (
            <tr>
              <th style={{ borderBottom: "1px solid black" }} scope="row">
                Nomor Surat
              </th>
              <td style={{ borderBottom: "1px solid black" }}>
                {data.nomor_surat}
              </td>
            </tr>
          )}
          <tr>
            <th style={{ borderBottom: "1px solid black" }} scope="row">
              Perihal
            </th>
            <td style={{ borderBottom: "1px solid black" }}>{data.perihal}</td>
          </tr>
          {data.lampiran && (
            <tr>
              <th style={{ borderBottom: "1px solid black" }} scope="row">
                Lampiran
              </th>
              <td style={{ borderBottom: "1px solid black" }}>
                {data.lampiran} ({numberToText(data.lampiran)}){" "}
                {data.satuan_lampiran}
              </td>
            </tr>
          )}
          {data.isi_lampiran && (
            <tr>
              <th style={{ borderBottom: "1px solid black" }} scope="row">
                Isi Lampiran
              </th>
              <td style={{ borderBottom: "1px solid black" }}>
                {numbering(data.isi_lampiran)}
              </td>
            </tr>
          )}
          {data.catatan && (
            <tr>
              <th style={{ borderBottom: "1px solid black" }} scope="row">
                Catatan
              </th>
              <td style={{ borderBottom: "1px solid black" }}>
                {data.catatan}
              </td>
            </tr>
          )}
          <>
            <br />
            <br />
            <tr>
              <th style={{ borderBottom: "1px solid black" }} scope="row">
                Pemberi Tugas
              </th>
              <td style={{ borderBottom: "1px solid black" }}></td>
            </tr>
            <tr>
              <td colSpan={2}>
                <SignTable
                  datatable={pemberiTugasList}
                  type="pemberi_tugas"
                  resetState={refreshPemberiTugas}
                />
              </td>
            </tr>
          </>
          {checkPermission(PERMISSIONS.ADD_TANDA_TANGAN_YANG_MENYERAHKAN) && (
            <>
              <br />
              <br />
              <br />
              <tr>
                <th style={{ borderBottom: "1px solid black" }} scope="row">
                  Yang Menyerahkan
                </th>
                {yangMenyerahkanList.length === 0 ? (
                  <td style={{ borderBottom: "1px solid black" }}>
                    <SignForm
                      idTandaTerima={data.id_tanda_terima}
                      resetState={refreshYangMenyerahkan}
                      type="yang_menyerahkan"
                    />
                  </td>
                ) : (
                  <td style={{ borderBottom: "1px solid black" }}></td>
                )}
              </tr>
              {yangMenyerahkanList.length > 0 && (
                <tr>
                  <td colSpan={2}>
                    <SignTable
                      status={data.status}
                      datatable={yangMenyerahkanList}
                      type="yang_menyerahkan"
                      resetState={refreshYangMenyerahkan}
                      />
                  </td>
                </tr>
              )}
            </>
          )}
          {checkPermission(PERMISSIONS.ADD_TANDA_TANGAN_PENERIMA) && (
            <>
              <br />
              <br />
              <tr>
                <th style={{ borderBottom: "1px solid black" }} scope="row">
                  Penerima
                </th>
                <td style={{ borderBottom: "1px solid black" }}></td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <SignTable
                    status={data.status}
                    datatable={penerimaList}
                    type="penerima"
                    resetState={refreshPenerima}
                  />
                </td>
              </tr>
            </>
          )}
        </tbody>
      </Table>

      <Button
        className="align-self-end mt-5"
        onClick={() => cetakTandaTerima(data.id_tanda_terima)}
      >
        Cetak
      </Button>
    </div>
  );
};

export default DetailTandaTerima;
